export default "__VITE_PUBLIC_ASSET__4881314d__"